import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Platform } from "react-native";
import { useTranslations } from "@src/packages/i18n";
import type { OnboardingStackParamList } from "../types";
import { AccountAccessScreen } from "./CreateAccountScreen";

type Props = NativeStackScreenProps<OnboardingStackParamList, "Login">;

export default function LoginScreen({ navigation, route }: Props) {
  const t = useTranslations();
  const hasAuthError =
    route.params?.authError === "oauth" ||
    (Platform.OS === "web" &&
      typeof window !== "undefined" &&
      new URLSearchParams(window.location.search).get("auth_error") ===
        "oauth");

  return (
    <AccountAccessScreen
      navigation={navigation}
      variant="login"
      initialError={
        hasAuthError ? t("onboarding.login.oauth_error") : undefined
      }
    />
  );
}
